import React from 'react'
import Dashboard from '../../components/superAdmin/dashboard/Dashboard'

function SuperAdminDashbordPage() {
  return (
    <div>
        <Dashboard />
    </div>
  )
}

export default SuperAdminDashbordPage